// @ts-nocheck
// Shared MUI Dialog close-guard.
//
// By default a MUI <Dialog> dismisses when the user clicks the backdrop
// (outside the dialog) or presses Escape. On touch screens the backdrop tap
// is far too easy to trigger by accident — you lose a half-filled form or
// close a document you were reading. WeSafe policy: dialogs close only via an
// explicit Close (X) button or a Cancel/action button.
//
// Wrap your close handler with this and pass it as the Dialog's `onClose`:
//
//   <Dialog onClose={dialogCloseGuard(onClose)} ...>
//
// Backdrop clicks are always swallowed. Escape is swallowed too by default
// (keeps behaviour identical across desktop + mobile); pass
// `{ allowEscape: true }` if a particular dialog should still close on Esc.
export function dialogCloseGuard(onClose, { allowEscape = false } = {}) {
  return (_event, reason) => {
    if (reason === 'backdropClick') return;
    if (!allowEscape && reason === 'escapeKeyDown') return;
    onClose?.();
  };
}
